/** @format */

const assessment = {
    mainIcon: '/assets/images/svg/tir/icon-main.svg',
    buildingIcon: '/assets/images/svg/tir/icon-building.svg',
    handStarsIcon: '/assets/images/svg/tir/hand-stars-outline.svg',
    lightBulbIcon: '/assets/images/svg/tir/light-bulb.svg',
    userGroupAddIcon: '/assets/images/svg/tir/usergroup-add-outline.svg',
    reportIcon: '/assets/images/svg/tir/letter.svg',
    historyIcon: '/assets/images/svg/tir/history.svg',
    downloadIcon: '/assets/images/svg/tir/download.svg',
    insightIcon: '/assets/images/svg/tir/team.svg',
    roundedCheckIcon: '/assets/images/svg/tir/rounded-check.svg',
    listIcon: '/assets/images/svg/tir/list-icon.svg',
    bgTitleTest: '/assets/images/svg/tir/bg-title-test.svg',
    scoreIcon: '/assets/images/svg/tir/score-icon.svg',
    shareIcon: '/assets/images/svg/tir/share.svg',
    iconCTBlack: '/assets/images/svg/tir/icon-ct-black.svg',
    loadingTest: '/assets/images/svg/tir/loading_test.svg',
    hiddenMiniReport: '/assets/images/svg/tir/hidden_mini_report.svg',

    //graph
    gauss: 'url("/assets/images/png/common/bg-gausse-web.png")',
    pointerGauss: 'url("/assets/images/png/common/pointer-gausse-web.png")',
    barre: 'url(/assets/images/png/common/bg-barre-web.png)',
    barrePointer: 'url(/assets/images/png/common/pointer-barre-web.png)',
}

export default assessment